'use client';

import { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import type { Attorney } from '@jlg-website/database/types';
import { TeamCarouselServer } from './server';

export default function TeamCarousel({
  attorneys,
  showLinks,
}: {
  attorneys: Attorney[];
  showLinks?: boolean;
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'center',
    dragFree: false,
    containScroll: 'trimSnaps',
  });

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(true);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);

    // Initial state sync to satisfy lint (asynchronous)
    const timeout = setTimeout(onSelect, 0);

    return () => {
      clearTimeout(timeout);
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <TeamCarouselServer
      attorneys={attorneys}
      emblaRef={emblaRef}
      canScrollPrev={canScrollPrev}
      canScrollNext={canScrollNext}
      emblaApi={emblaApi}
      showLinks={showLinks}
    />
  );
}
